import { predelavaService } from '../services/predelava.service';
import Vue from 'vue';


const state = {
    predelava: null,
    predelovalec:{},
    sezona:null,
   storedfilter: {
                logic: "and",
                filters: [
                    { field: "jeaktivna", operator: "neq", value: 0}
                ]
            },
};

const actions = {
     clear({ dispatch,commit }) {
       
       dispatch('alert/clear', "",{ root: true });
       let predelovalec={};
       commit('loadOne', predelovalec)
     },
    load({ dispatch, commit },{sezona}) {
     
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
         return predelavaService.load(sezona)
            .then(
                predelava =>  {
                 
                    commit('load', predelava);
                    return predelava;
                },
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                }
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    
    loadIdPoSezoni({ dispatch,commit },{sezona,subjid}) {
   
          dispatch('alert/clear', "",{ root: true });
       return new Promise((resolve, reject) => {

        predelavaService.loadIdPoSezoni(sezona,subjid)
            .then(
                predelovalec => {
                  if(predelovalec==""){
                    var error="predelovalec v tej sezoni ne obstaja!";
                      console.log(error);
                    dispatch('alert/error', error, { root: true });
                    reject(error);
                  }
                    else {
                  
                commit('loadOne', predelovalec)
                resolve(predelovalec)
                }
              },
                error => {
                    console.log("predelovalec v tej sezoni ne obstaja!");
                    dispatch('alert/error', error, { root: true });
                    reject(error);
            }
            )

          });
    },

    loadOne({ dispatch,commit },{sezona,predelovalecid}) {
   
          dispatch('alert/clear', "",{ root: true });
            return new Promise((resolve, reject) => {

        predelavaService.loadOne(sezona,predelovalecid)
            .then(
                predelovalec => {

                  commit('loadOne', predelovalec)
                  resolve(predelovalec);

              },
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                    reject(error)
            }
            );
          });
            
    },
   
   loadbyds({ dispatch,commit },{ds}) {
        
          dispatch('alert/clear', "",{ root: true });
        return predelavaService.loadbyds(ds)
            .then(
                predelovalec => {
                    
                    if(!predelovalec){
                    dispatch('alert/error', "predelovalec s to številko ni bil najden!", { root: true });
                     predelovalec={};
            }
                 //   else if (!predelovalec.kmgmid)    
                   //      dispatch('alert/warning', "Ta predelovalec ni nosilec kmetijskega gospodarstva!", { root: true });
                 
                 commit('loadOne', predelovalec)
             }

                //,
                //error => commit('getLoggedInFailure', error)
            ),
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                   
            };
    },
    loadbymso({ dispatch,commit },{mso}) {
        //commit('load');
          dispatch('alert/clear', "",{ root: true });
        return predelavaService.loadbymso(mso)
            .then(
                predelovalec => {
                   
                    if(!predelovalec){
                    dispatch('alert/error', "predelovalec s to številko ni bil najden!", { root: true });
                    predelovalec={}
                    }
                //    else if (!predelovalec.kmgmid)    
                  //       dispatch('alert/warning', "Ta predelovalec ni nosilec kmetijskega gospodarstva!", { root: true });


                    commit('loadOne', predelovalec)
                }
                //,
                //error => commit('getLoggedInFailure', error)
            ),
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                   
            };
    },
     saveobrat({ dispatch,commit },{kontrolnastevilka,sezona}) {
        

        commit('updatekontrolnastevilka', kontrolnastevilka)
        commit('updatesezona', sezona)
        let predelovalec=this.state.predelava.predelovalec;
       dispatch('alert/clear', "",{ root: true });

          return new Promise((resolve, reject) => {
            if(!kontrolnastevilka) {
                var error="Kontrolna številka je prazna!"
            console.log(error);
            dispatch('alert/error', error, { root: true });
            reject(error)
            }
            else{

                  
                predelavaService.add(predelovalec)
            .then(
                predelovalec => {
                    
                    if(!predelovalec){
                    dispatch('alert/error', "predelovalec s to številko ni bil najden!", { root: true });    
                     predelovalec={};
                }
                commit('loadOne', predelovalec)
                 dispatch('alert/success', "predelovalec je bil uspešno shranjen!", { root: true });   
                resolve(predelovalec);
                },
                error => {
                    console.log("Nalaganje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                    reject(error)
                   
            });


           }


          });


    },
     save({ dispatch,commit },{sezona}) {
        

        
        commit('updatesezona', sezona)
        let predelovalec=this.state.predelava.predelovalec;
       dispatch('alert/clear', "",{ root: true });

          return new Promise((resolve, reject) => {
                predelavaService.save(predelovalec)
            .then(
                predelovalec => {
                    
                  
                 dispatch('alert/success', "Podatki o predelovalcu so bili uspešno shranjeni!", { root: true });   
                resolve(predelovalec);
                },
                error => {
                    console.log("Shranjevanje ni uspelo");
                    dispatch('alert/error', error, { root: true });
                    reject(error)
                   
            });


        


          });


    },
    select({ commit },{predelovalec}) {
        commit('loadOne',predelovalec);

    },
    replace({ commit },{predelava}) {
        commit('replace',predelava);

    }
};

const mutations = {
     setSezona(state, item) {
        state.sezona=item;
    },
    load(state, predelava) {
      state.predelava=predelava.map(k=>{
            k["datumdolocitvestatusa"]=kendo.parseDate(k["datumdolocitvestatusa"]) 
            return k;
        });
       // state.predelava = predelava;
    },
    replace(state, predelava) {
        state.predelava = predelava;
    },
    loadOne(state, predelovalec) {
         //state.predelovalec = Object.assign({}, this.someObject,predelovalec)
         state.predelovalec=predelovalec;
         
         
    },
    updatefilter(state, filter) {
          state.storedfilter=filter;
         
    },
    updatemso(state, mso) {
         Vue.set( state.predelovalec, 'mso',mso);
         
    },
    updateds(state, ds) {
         Vue.set( state.predelovalec, 'ds',ds);
         
    },
    
    updatekmgmid(state, kmgmid) {
         Vue.set( state.predelovalec, 'kmgmid',kmgmid);
         
    },
     updatekontrolnastevilka(state, kontrolnastevilka) {
         Vue.set( state.predelovalec, 'kontrolnastevilka',kontrolnastevilka);
         
    },
    
     updatesezona(state, sezona) {
         Vue.set( state.predelovalec, 'sezona',sezona);
         
    },
      updatestatusid(state, statusid) {
         Vue.set( state.predelovalec, 'statusid',statusid);
         
    },
    
      updatedatumdolocitvestatusa(state, datumdolocitvestatusa) {
         Vue.set( state.predelovalec, 'datumdolocitvestatusa',datumdolocitvestatusa);
         
    },
      updateprop(state, {property,value}) {
         Vue.set( state.predelovalec, property,value);
         
    },
    
    
    loadOne(state, predelovalec) {
         //state.predelovalec = Object.assign({}, this.someObject,predelovalec)
         state.predelovalec=predelovalec;
         
         
    },
    
    save(state, predelovalec) {
        
        state.predelovalec = predelovalec;
    },
   
};

export const predelava = {
    namespaced: true,
    state,
    actions,
    mutations
};
